import { Get } from '../api/server';

export function getUpcomingEvents(companyId) {
  return Get(`/events/byCompany/getUpcomingEvents/${companyId}`);
}

export function getEventBySlug(slug) {
  return Get(`/events/getEvent/${slug}`);
}
